module.exports = __webpack_public_path__ + "img/canduyet-sidebar-unactive.f85445d8.svg";